module.exports = __webpack_public_path__ + "img/rolling_32.fbf0e558.svg";